import taxonomy from './supplierTaxonomy.json';

export const supplierTaxonomy = taxonomy;
export const supplierCategories = taxonomy.categories;
export const supplierCategoryValues = [
  ...taxonomy.categories.map(category => category.value),
  ...(taxonomy.legacyCategoryValues || [])
];
export const supplierCategoryLabels = taxonomy.categoryLabels;
export const supplierWeddingTypes = taxonomy.weddingTypes;
export const supplierVibeTags = taxonomy.vibeTags;
export const supplierFormalityOptions = taxonomy.formalityOptions;
export const supplierStyleOptions = taxonomy.styleOptions;
export const supplierCategoryGroups = taxonomy.categoryGroups;

export const isInCategoryGroup = (category, groupName) =>
  (supplierCategoryGroups[groupName] || []).includes(category);

/** Human-readable label for a category value (API snake_case), not the raw value. */
export const getSupplierCategoryLabel = (category) => {
  if (!category) return 'Uncategorized';
  if (supplierCategoryLabels[category]) return supplierCategoryLabels[category];
  return category
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
};
